import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "../api/axiosInstance";
import toast, { Toaster } from "react-hot-toast";
import { motion } from "framer-motion";

const LoginForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post("/api/accounts/adminlogin/", formData);
      const { access, refresh, user } = response.data;

      sessionStorage.setItem("accessToken", access);
      sessionStorage.setItem("refreshToken", refresh);
      sessionStorage.setItem("user", JSON.stringify(user));

      toast.success("Login successful!");
      navigate("/admin-html-secure-metro");
    } catch (error) {
      console.error(
        "Login error:",
        error.response?.data || error.message || error
      );
      toast.error(
        "Login failed: " +
          (error.response?.data?.error || error.message || "Unknown error")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
      className="min-h-screen flex items-center justify-center bg-gray-50 p-4"
    >
      <Toaster position="top-center" reverseOrder={false} />
      <div className="bg-white shadow-lg rounded-2xl p-8 max-w-md w-full">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-6 text-center">
          Admin Login
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-sm text-gray-600">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-yellow-400"
            />
          </div>

          <div>
            <label className="text-sm text-gray-600">Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-yellow-400"
            />
          </div>

          {/* Forgot Password Link */}
          {/* <div className="text-right">
            <Link
              to="/forgot-password"
              className="text-xs text-orange-500 hover:underline"
            >
              Forgot Password?
            </Link>
          </div> */}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 rounded-lg transition duration-200"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        {/* Register link */}
        {/* <p className="text-sm text-center text-gray-600 mt-4">
          Don't have an account?{" "}
          <Link
            to="/"
            className="text-orange-500 hover:underline font-medium"
          >
            Register
          </Link>
        </p> */}

        <p className="text-xs text-center text-gray-400 mt-6">
          © 2025 Matrimonial Platform. All rights reserved.
        </p>
      </div>
    </motion.div>
  );
};

export default LoginForm;
